var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_53471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5717 2.92857C13.6664 -0.976298 7.33455 -0.976733 3.42881 2.92857C-0.476489 6.83387 -0.476054 13.1657 3.42881 17.0715C7.33412 20.9759 13.666 20.9764 17.5717 17.0715C21.4766 13.1657 21.4762 6.83431 17.5717 2.92857ZM11.8042 14.3479C11.8042 15.0684 11.2203 15.6523 10.4998 15.6523C9.77939 15.6523 9.19546 15.0684 9.19546 14.3479V9.13044C9.19546 8.40999 9.77939 7.82607 10.4998 7.82607C11.2203 7.82607 11.8042 8.40999 11.8042 9.13044V14.3479ZM10.4768 6.90083C9.72547 6.90083 9.22459 6.36864 9.24024 5.71167C9.22459 5.02296 9.72547 4.50686 10.492 4.50686C11.259 4.50686 11.7442 5.0234 11.7603 5.71167C11.7599 6.36864 11.2594 6.90083 10.4768 6.90083Z",
    fill: "#F66060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_53471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/NotVerified.55a46d101c1f9b2a213abc1e3c470471.svg";
export { ForwardRef as ReactComponent };